import React, { createRef, useEffect, useState } from 'react';
import { Renderer } from 'vexflow4';
import { Handler, SCORE_STORE_KEY } from '../common/handler';
import TopNavBar from './TopNavBar';
import { NoteActionButton } from './NoteActionButton';
import axios from 'axios';
import { getUrlParam } from '../utils/helpers';
import { base_url } from '../config';

import 'weui';
import 'react-weui-ts/build/dist/react-weui.css';

import '../styles/vexEditor.css';
import ChordPopup from './ChordPopup';
import { StaveNote } from '../common/extension/MusiconStaveNote';
import { Toast } from 'antd-mobile';
import { doPostMessage } from '../utils/rn';


const VexEditor = () => {
    const containerRef = createRef<any>();
    const [handler, setHandler] = useState<Handler | null>(null);
    const [showChordPopup, setShowChordPopup] = useState(false);
    const [title, setTitle] = useState('');
    const [touched, setTouched] = useState(false);
    const [isVip, setIsVip] = useState(true);
    const [uuid, setUuid] = useState('');

    const initStave = () => {
        const vip = localStorage.getItem('vip');
        setIsVip(parseInt(vip ?? '0') === 1)
        doPostMessage({ vip }, 'stave-editor-loaded');
        const title = localStorage.getItem('title');
        setTitle(title ?? '');

        const render = new Renderer(containerRef.current ?? '', Renderer.Backends.CANVAS);
        render.resize(2000, 260);

        // const uuid = localStorage.getItem('stave_id');
        // updateStaff(uuid ?? '');

        // 初始化handler
        const handler = Handler.getInstance(render);

        handler.init();
        handler.startListenTouchEvent(containerRef.current);

        setHandler(handler);

    }

    useEffect(() => {
        initStave();

        return () => {
            handler?.stopListenTouchEvent(containerRef.current);
        }
    }, []);

    const pickNote = (note: string | null) => {
        if (!handler) {
            return;
        }
        let duration = null;
        switch (note) {
            case 'full':
                duration = '1';
                break;
            case 'half':
                duration = '2';
                break;
            case 'quarter':
            default:
                duration = '4';
                break;
        }

        handler.duration = duration;
    };

    const downKeys = () => {
        if (!handler) {
            return;
        }

        handler.downAllKeys();
    };

    const upKeys = () => {
        if (!handler) {
            return;
        }

        handler.upAllKeys();
    };

    const updateScore = () => {
        initStave();
    }

    return (
        <React.Fragment>
            <TopNavBar
                title={title}
                pickNote={(note: string | null) => pickNote(note)}
                handler={handler}
                showChordPopup={() => {
                    const melodyNotes: StaveNote[] = handler?.getNoteList() ?? [];

                    if (melodyNotes.length > 0) {
                        setShowChordPopup(true);
                    } else {
                        Toast.show({
                            content: '请先输入旋律音符',
                        });
                    }
                }}
                isMember={isVip}
                touched={touched}
                uuid={uuid}
                onSuccess={({ uuid, title }) => {
                    setUuid(uuid);
                    setTitle(title);
                }}
            />
            <div id="update-score" onClick={updateScore}></div>
            <div
                className="canvas-container"
                onTouchEnd={() => {
                    setTouched(!touched);
                }}
            >
                <canvas ref={containerRef} />
            </div>
            <NoteActionButton
                downAction={downKeys}
                upAction={upKeys}
                deleteAction={() => handler?.deleteNote()}
                cleanAll={() => handler?.cleanAll()}
                title={title}
            />
            <ChordPopup
                show={showChordPopup}
                close={() => {
                    setShowChordPopup(false);
                }}
                handler={handler}
            />
        </React.Fragment>
    )
};


export default VexEditor;
